import create from './create/text.js';
import detail from './detail/text.js';
import list from './list/text.js';
import model from './model/text.js';

export default {
  detail,
  list,
  model,
  action: {
    markOrdered: {
      notes: 'Title of action that mark selected items as ordered',
      message: 'Mark ordered',
    },
    copyToCart: {
      notes: 'Title of copy recommendation items to cart button',
      message: 'Copy to cart',
    },
    addToRecommendation: {
      notes: 'Menu action for adding items to a new or existing recommendation',
      message: 'Add to recommendation',
    },
  },
  create,
  notifications: {
    successfullyAdded: {
      notes:
        'Toast message indicating an item (or items) was successfully added to a recommendation',
      message: {
        zero: '',
        one: '{{displayName}} added to recommendation',
        other: '{{count}} items added to recommendation',
      },
    },
    successfullyCreated: {
      notes: 'Toast message when a recommendation was successfully created',
      message: 'Recommendation created successfully',
    },
  },
  dialogs: {
    remove: {
      title: {
        notes: 'Title of remove recommendation dialog',
        message: 'Remove recommendation list',
      },
      content: {
        notes: 'Content of remove recommendation dialog',
        message:
          'Are you sure you want to remove recommendation {{recommendationTopic}}? This action can not be undone.',
      },
    },
    addTo: {
      title: {
        add: {
          notes: 'Dialog title when adding to an existing recommendation',
          message: 'Add to recommendation',
        },
        new: {
          notes: 'Dialog title when creating a new recommendation',
          message: 'New recommendation',
        },
      },
      tabs: {
        existing: {
          notes: 'Title on tab for choosing an existing recommendation',
          message: 'Existing recommendation',
        },
        new: {
          notes: 'Title on tab for creating a new recommendation',
          message: 'New recommendation',
        },
      },
    },
  },
};
